import React, { useState, useEffect } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import { renderField } from '../../../utilities/reduxForm.util'
import { required, emailValidator } from '../../../utilities/validators'
import Loader from '../../Loader/Loader'

const ForgotPasswordForm = props => {
  const { error, submitting, handleSubmit, submitSucceeded, reset } = props
  const [modal, setModal] = useState(false)
  const modalId = 'password-reset-success-modal'
  const modalTitleId = 'password-reset-success-title'

  useEffect(() => {
    if (submitSucceeded) {
      toggleModal()
      reset()
    }
  }, [submitSucceeded, reset])

  const toggleModal = () => {
    setModal(!modal)
  }

  return (
    <div className="forgot-password-form-container">
      <form onSubmit={handleSubmit} method="post" aria-label="Password reset request form">
        <div className="form-group">
          <Field
            component={renderField}
            validate={[required, emailValidator]}
            type="email"
            inputType="input"
            name="email"
            id="reset-email"
            label="global.label.email"
            aria-required="true"
          />
        </div>

        {error && (
          <div className="form-validation-error-message mb-2" role="alert" aria-live="assertive">
            <FormattedMessage id={error} />
          </div>
        )}

        {submitting ? (
          <div aria-live="polite">
            <Loader />
          </div>
        ) : (
          <Button
            name="forgetPasswordFormSubmitBtn"
            type="submit"
            outline
            color="dark"
            block
            aria-label="Reset password"
          >
            <FormattedMessage id="global.label.resetPassword" />
          </Button>
        )}
      </form>

      <Modal
        isOpen={modal}
        toggle={toggleModal}
        id={modalId}
        aria-labelledby={modalTitleId}
        role="dialog"
      >
        <ModalHeader toggle={toggleModal}>
          <span className="sr-only">
            <FormattedMessage id="global.label.close" defaultMessage="Close" />
          </span>
        </ModalHeader>
        <ModalBody>
          <h2 id={modalTitleId} className="text-center">
            <FormattedMessage id="success.passwordReset.resentTitle" />
          </h2>
          <p>
            <FormattedMessage id="success.passwordReset.resentDescription" />
          </p>
        </ModalBody>
        <ModalFooter>
          <div className="w-100">
            <div className="row">
              <div className="col">
                <Button
                  block
                  outline
                  color="light"
                  onClick={toggleModal}
                  aria-label="Close this message"
                >
                  <FormattedMessage id="global.label.popoverClose" />
                </Button>
              </div>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  )
}

ForgotPasswordForm.propTypes = {
  error: PropTypes.string,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  submitSucceeded: PropTypes.bool,
  reset: PropTypes.func.isRequired,
}

export default reduxForm({
  form: 'forgotPasswordForm',
  validate: () => ({}),
})(ForgotPasswordForm)
